import React, { useState } from "react";
import { T, fmt } from "./theme";
import { SectionHeader, Card, Input, Textarea, Btn, Note } from "./ui";
import { Icon } from "./Icons";

// ═══════════════════════════════════════════════════════════════════════
// ACELERADORES + METAS (admin)
// Edita: metaVolume, metaAtivacoes, prêmios e % de bônus por camada
// ═══════════════════════════════════════════════════════════════════════

export default function Aceleradores({ metas, setMetas, aceleradores, setAceleradores }) {
  const [eM, setEM] = useState(metas);
  const [eA, setEA] = useState(aceleradores);
  const [saved, setSaved] = useState(false);

  function salvar() {
    setMetas(eM);
    setAceleradores(eA);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  }

  function updateMeta(camada, campo, valor) {
    setEM({ ...eM, [camada]: { ...eM[camada], [campo]: valor } });
  }

  // Cenário de exemplo: time supermeta + regional supermeta + nacional supermeta
  const exemploMax = eA.timeSupermeta + eA.regionalSupermeta + eA.nacionalSupermeta;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeader
        title="Metas & Aceleradores"
        subtitle="Configure as metas coletivas por camada e os bônus de pontuação para corretores elegíveis"
        icon={<Icon.rocket size={24} />}
        right={
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {saved && <span style={{ fontSize: 11, color: T.ok, fontWeight: 600 }}>✓ Salvo!</span>}
            <Btn onClick={salvar} icon={<Icon.check size={14} />}>Salvar alterações</Btn>
          </div>
        }
      />

      <Note tone="info" icon={<Icon.info size={14} />}>
        Cada camada tem <b>2 metas independentes</b> (Volume R$ + Ativações). Bater 1 delas libera o acelerador de <b>meta</b>. Bater ambas libera o de <b>supermeta</b> (bônus maior). Aceleradores são <b>cumulativos</b> entre camadas.
      </Note>

      {/* CAMADA TIME */}
      <Card>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 10 }}>
          <div>
            <div className="serif" style={{ fontSize: 20, fontWeight: 600, color: T.brand, letterSpacing: -0.3 }}>
              Times (semanal)
            </div>
            <div style={{ fontSize: 11, color: T.textSub, marginTop: 2 }}>
              Ciclo: segunda a domingo · avaliado por time
            </div>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <Input
            label="Meta Volume (R$)"
            type="number"
            value={eM.time.metaVolume}
            onChange={e => updateMeta("time", "metaVolume", Number(e.target.value))}
            hint={`Atual: ${fmt.brl(eM.time.metaVolume)}`}
          />
          <Input
            label="Meta Ativações (quantidade)"
            type="number"
            value={eM.time.metaAtivacoes}
            onChange={e => updateMeta("time", "metaAtivacoes", Number(e.target.value))}
            hint="Corretores com venda nos últimos 90d"
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 14 }}>
          <Input
            label="Prêmio Meta Volume"
            value={eM.time.premioVolume}
            onChange={e => updateMeta("time", "premioVolume", e.target.value)}
          />
          <Input
            label="Prêmio Meta Ativações"
            value={eM.time.premioAtivacoes}
            onChange={e => updateMeta("time", "premioAtivacoes", e.target.value)}
          />
          <Input
            label="Prêmio Supermeta"
            value={eM.time.premioSupermeta}
            onChange={e => updateMeta("time", "premioSupermeta", e.target.value)}
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: 14, background: T.cardSoft, borderRadius: T.r.md }}>
          <Input
            label="Acelerador bateu 1 meta (pontos)"
            type="number"
            value={eA.timeMeta}
            onChange={e => setEA({ ...eA, timeMeta: Number(e.target.value) })}
            hint="Pontos de bônus pro corretor"
          />
          <Input
            label="Acelerador Supermeta (pontos)"
            type="number"
            value={eA.timeSupermeta}
            onChange={e => setEA({ ...eA, timeSupermeta: Number(e.target.value) })}
            hint="Quando bate as DUAS metas"
          />
        </div>
      </Card>

      {/* CAMADA REGIONAL */}
      <Card>
        <div className="serif" style={{ fontSize: 20, fontWeight: 600, color: T.brand, letterSpacing: -0.3, marginBottom: 2 }}>
          Regional (mensal)
        </div>
        <div style={{ fontSize: 11, color: T.textSub, marginBottom: 14 }}>
          Ciclo: 1º ao último dia do mês · avaliado por UF
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <Input
            label="Meta Volume (R$)"
            type="number"
            value={eM.regional.metaVolume}
            onChange={e => updateMeta("regional", "metaVolume", Number(e.target.value))}
            hint={`Atual: ${fmt.brl(eM.regional.metaVolume)}`}
          />
          <Input
            label="Meta Ativações"
            type="number"
            value={eM.regional.metaAtivacoes}
            onChange={e => updateMeta("regional", "metaAtivacoes", Number(e.target.value))}
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 14 }}>
          <Input label="Prêmio Meta Volume" value={eM.regional.premioVolume} onChange={e => updateMeta("regional", "premioVolume", e.target.value)} />
          <Input label="Prêmio Meta Ativações" value={eM.regional.premioAtivacoes} onChange={e => updateMeta("regional", "premioAtivacoes", e.target.value)} />
          <Input label="Prêmio Supermeta" value={eM.regional.premioSupermeta} onChange={e => updateMeta("regional", "premioSupermeta", e.target.value)} />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: 14, background: T.cardSoft, borderRadius: T.r.md }}>
          <Input label="Acelerador Meta (pontos)" type="number" value={eA.regionalMeta} onChange={e => setEA({ ...eA, regionalMeta: Number(e.target.value) })} />
          <Input label="Acelerador Supermeta (pontos)" type="number" value={eA.regionalSupermeta} onChange={e => setEA({ ...eA, regionalSupermeta: Number(e.target.value) })} />
        </div>
      </Card>

      {/* CAMADA NACIONAL */}
      <Card>
        <div className="serif" style={{ fontSize: 20, fontWeight: 600, color: T.brand, letterSpacing: -0.3, marginBottom: 2 }}>
          Nacional (mensal)
        </div>
        <div style={{ fontSize: 11, color: T.textSub, marginBottom: 14 }}>
          Operação inteira Bellanor
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <Input
            label="Meta Volume (R$)"
            type="number"
            value={eM.nacional.metaVolume}
            onChange={e => updateMeta("nacional", "metaVolume", Number(e.target.value))}
            hint={`Atual: ${fmt.brl(eM.nacional.metaVolume)}`}
          />
          <Input
            label="Meta Ativações"
            type="number"
            value={eM.nacional.metaAtivacoes}
            onChange={e => updateMeta("nacional", "metaAtivacoes", Number(e.target.value))}
          />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 14 }}>
          <Input label="Prêmio Meta Volume" value={eM.nacional.premioVolume} onChange={e => updateMeta("nacional", "premioVolume", e.target.value)} />
          <Input label="Prêmio Meta Ativações" value={eM.nacional.premioAtivacoes} onChange={e => updateMeta("nacional", "premioAtivacoes", e.target.value)} />
          <Input label="Prêmio Supermeta" value={eM.nacional.premioSupermeta} onChange={e => updateMeta("nacional", "premioSupermeta", e.target.value)} />
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, padding: 14, background: T.cardSoft, borderRadius: T.r.md }}>
          <Input label="Acelerador Meta (pontos)" type="number" value={eA.nacionalMeta} onChange={e => setEA({ ...eA, nacionalMeta: Number(e.target.value) })} />
          <Input label="Acelerador Supermeta (pontos)" type="number" value={eA.nacionalSupermeta} onChange={e => setEA({ ...eA, nacionalSupermeta: Number(e.target.value) })} />
        </div>
      </Card>

      {/* SIMULAÇÃO */}
      <Card soft>
        <div style={{ fontSize: 11, color: T.textSub, textTransform: "uppercase", letterSpacing: 1, fontWeight: 600, marginBottom: 12 }}>
          💡 Simulação: cenário máximo
        </div>
        <div style={{ fontSize: 13, color: T.text, lineHeight: 1.7 }}>
          Um corretor elegível cujo <b>time</b>, <b>regional</b> E <b>nacional</b> todos baterem a <b>supermeta</b> ganhará um bônus total de <b style={{ color: T.ok, fontSize: 18 }}>+{exemploMax} pts</b> no ciclo.
        </div>
        <div style={{ fontSize: 11, color: T.textSub, marginTop: 8 }}>
          Exemplo: corretor com 100 pts no ciclo + {exemploMax} pts = <b style={{ color: T.brand }}>{100 + exemploMax} pts totais</b>.
        </div>
      </Card>
    </div>
  );
}
